import { Button } from '@change/ds-core-ui';
import { ArrowLeftIcon, ArrowRightIcon } from '@change/ds-icons';

import { useI18n } from '@change-corgi/core-react/i18n';

import { TopImpactStorySummary } from '../TopImpactStorySummary';

import { useFooter } from './hooks/useFooter';

type Props = {
	dataTestId: string;
};

export const Footer: React.FC<Props> = ({ dataTestId }) => {
	const {
		data: { currentStorySummary, isSummaryFading },
		actions: { onLeftClick, onRightClick },
	} = useFooter();

	const { translate } = useI18n();

	return (
		<div className="mb-6 flex items-center justify-center">
			<Button
				type="button"
				leadingIcon={<ArrowLeftIcon />}
				aria-label={translate('corgi.homepage.top_impact_stories.mobile.left_arrow_label')}
				onClick={onLeftClick}
				variant="tertiary"
				data-testid="left-arrow"
				data-qa="left-arrow"
				size="large"
				iconOnly
				className="text-icon-information"
			/>

			<TopImpactStorySummary
				summary={currentStorySummary}
				dataTestId={dataTestId}
				isMobile
				isFading={isSummaryFading}
			/>

			<Button
				type="button"
				leadingIcon={<ArrowRightIcon />}
				aria-label={translate('corgi.homepage.top_impact_stories.mobile.right_arrow_label')}
				onClick={onRightClick}
				variant="tertiary"
				data-testid="right-arrow"
				data-qa="right-arrow"
				size="large"
				iconOnly
				className="text-icon-information"
			/>
		</div>
	);
};
